// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"hd"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 4L22 20L2 20L2 4L14 4L18 4L22 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 4V20L2 20L2 4L22 4Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6 9V12M6 12H10M6 12V15M10 12V9M10 12V15M14 9V15H17C17.5523 15 18 14.5523 18 14V10C18 9.44772 17.5523 9 17 9H14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-hd')
export default class HdIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hd',
    }
  }
}
